import { MODEL_FORMAT_EXPORT } from 'Pods/ThreeDStudio/Store/constants'

export const EXPORT_FORMAT_LABELS = {
  [MODEL_FORMAT_EXPORT.GLB]: 'GLB',
  [MODEL_FORMAT_EXPORT.FBX]: 'FBX',
  [MODEL_FORMAT_EXPORT.OBJ]: 'OBJ',
  [MODEL_FORMAT_EXPORT.STL]: 'STL',
  [MODEL_FORMAT_EXPORT.USDZ]: 'USDZ',
}

export const EXPORT_FORMAT_ORDER = [
  MODEL_FORMAT_EXPORT.GLB,
  MODEL_FORMAT_EXPORT.FBX,
  MODEL_FORMAT_EXPORT.OBJ,
  MODEL_FORMAT_EXPORT.STL,
  MODEL_FORMAT_EXPORT.USDZ,
]
